import { api } from './index';

import type { ClientEvent, Event } from '@/types';

export const eventApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createClientEvent: builder.mutation<ClientEvent, Partial<ClientEvent>>({
      invalidatesTags: ['Event'],
      query: (clientEvent) => ({
        data: { clientEvent },
        method: 'POST',
        url: '/client_events',
      }),
    }),
    createEvent: builder.mutation<Event | null, Event>({
      invalidatesTags: ['Event'],
      query: (event) => ({
        data: { event },
        method: 'POST',
        url: '/events/',
      }),
    }),
    deleteEvent: builder.mutation<string | null, string>({
      invalidatesTags: ['Event'],
      query: (eventId) => ({
        method: 'DELETE',
        url: `/events/${eventId}`,
      }),
    }),
    getAllEvents: builder.query<Event[], void>({
      providesTags: ['Event'],
      query: () => ({
        method: 'GET',
        url: '/events?all=true',
      }),
    }),
    getClientEvents: builder.query<ClientEvent[], void>({
      providesTags: ['Event'],
      query: () => ({ method: 'GET', url: '/client_events' }),
    }),
    getEvents: builder.query<Event[], void>({
      providesTags: ['Event'],
      query: () => ({
        method: 'GET',
        url: '/events?all=false',
      }),
    }),
    updateClientEvent: builder.mutation<ClientEvent, Partial<ClientEvent>>({
      invalidatesTags: ['Event'],
      query: (clientEvent) => ({
        data: { clientEvent },
        method: 'PUT',
        url: `/client_events/${clientEvent.id}`,
      }),
    }),
    updateEvent: builder.mutation<
      Event | null, 
      Partial<Event> & { dismissedTill?: string }
    >({
      invalidatesTags: ['Event'],
      query: (event) => ({
        data: { event },
        method: 'PATCH',
        url: `/events/${event.id}`,
      }),
    }),
  }),
});

export const {
  useCreateClientEventMutation,
  useCreateEventMutation,
  useDeleteEventMutation,
  useGetAllEventsQuery,
  useGetClientEventsQuery,
  useGetEventsQuery,
  useUpdateClientEventMutation,
  useUpdateEventMutation,
} = eventApi;
